import NotionBoard from '../components/NotionBoard/NotionBoard'

type NotionsProps = {}

const Notions: React.FC<NotionsProps> = () => {
  return <NotionBoard></NotionBoard>
}

export default Notions
